import QueryString from 'query-string';
import React from 'react';
import { useLocation } from 'react-router-dom';

import LessonLauncherOffline from './LessonLauncherOffline';
import LessonLauncherOnline from './LessonLauncherOnline';

interface LessonLauncherProps { }
const LessonLauncher: React.FC<LessonLauncherProps> = () => {
  const location = useLocation();
  const { source } = QueryString.parse(location.search);
  if (source === 'offline') {
    return <LessonLauncherOffline />;
  }
  return <LessonLauncherOnline />;
};

export default LessonLauncher;
